export default {
  lang: {
    num: 'Τομέα',
    total: 'Άρθρο/Σύνολο',
    strip: 'Άρθρο',
    more: 'Περισσότερα.',
    chosen: 'Επιλεγμένα',
    cancel: 'Αποεπιλογή',
    bulkOperations: 'Λειτουργία παρτίδας',
    import: 'Εισαγωγή',
  },
};
